"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StatusText = _interopRequireDefault(require("../../../elements/StatusText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledStatusText = (0, _styledComponents.default)(_StatusText.default).withConfig({
  displayName: "StyledStatusText"
})(["padding-top:0;text-align:right;"]);

const StatusMessage = ({
  status
}) => /*#__PURE__*/_react.default.createElement(StyledStatusText, {
  modifiers: [status.type]
}, status.message);

StatusMessage.propTypes = {
  status: _propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    type: _propTypes.default.oneOf(['error', 'success']).isRequired
  }).isRequired
};
var _default = StatusMessage;
exports.default = _default;